import { useFormik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as Yup from "yup";

import { Card, CardBody, Col, Container, Input, Row } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "components/Common/BreadcrumbTitle";

import {
  editRolePermission,
  getRolePermission,
} from "../../http/fundLync/role.helper";
import { getRolePermissions, getRoles } from "../../store/actions";

//redux
import { useDispatch, useSelector } from "react-redux";


import TableContainerV1 from "components/Common/TableContainerV1";


const TableActionsComponent = (cellProps,handleCheckboxChange,handleChange) =>{

    const { row } = cellProps;
    const rowIndex = row.index;
    const rowData = row.original;
    return (
      <div className="d-flex">
        {rowData.view_permission !== null && (
          <div>
            <input
              type="checkbox"
              checked={rowData.view_permission == "1"}
              onChange={handleChange}
              onClick={() =>
                handleCheckboxChange(
                  "view_permission",
                  rowData.id,
                  rowIndex,
                  rowData
                )
              }
            />
            <label htmlFor="key1" className="me-4 ms-2">
              View
            </label>
          </div>
        )}

        {rowData.edit_permission !== null && (
          <div>
            <input
              type="checkbox"
              checked={rowData.edit_permission == "1"}
              onChange={handleChange}
              onClick={() =>
                handleCheckboxChange(
                  "edit_permission",
                  rowData.id,
                  rowIndex,
                  rowData
                )
              }
            />
            <label htmlFor="key2" className="me-4 ms-2">
              Edit
            </label>
          </div>
        )}

        {rowData.delete_permission !== null && (
          <div>
            <input
              type="checkbox"
              checked={rowData.delete_permission == "1"}
              onChange={handleChange}
              onClick={() =>
                handleCheckboxChange(
                  "delete_permission",
                  rowData.id,
                  rowIndex,
                  rowData
                )
              }
            />
            <label htmlFor="key3" className="me-4 ms-2">
              Delete
            </label>
          </div>
        )}

        {rowData.create_permission !== null && (
          <div>
            <input
              type="checkbox"
              checked={rowData.create_permission == "1"}
              onChange={handleChange}
              onClick={() =>
                handleCheckboxChange(
                  "create_permission",
                  rowData.id,
                  rowIndex,
                  rowData
                )
              }
            />
            <label htmlFor="key4" className="me-4 ms-2">
              Create
            </label>
          </div>
        )}

        {rowData.approve_permission !== null && (
          <div>
            <input
              type="checkbox"
              checked={rowData.approve_permission == "1"}
              onChange={handleChange}
              onClick={() =>
                handleCheckboxChange(
                  "approve_permission",
                  rowData.id,
                  rowIndex,
                  rowData
                )
              }
            />
            <label htmlFor="key4" className="me-4 ms-2">
              Approve
            </label>
          </div>
        )}

        {rowData.full_access !== null && (
          <div>
            <input
              type="checkbox"
              checked={rowData.full_access == "1"}
              onChange={handleChange}
              onClick={() =>
                handleCheckboxChange(
                  "full_access",
                  rowData.id,
                  rowIndex,
                  rowData
                )
              }
            />
            <label htmlFor="key1" className="me-4 ms-2">
              Fullaccess
            </label>
          </div>
        )}

        {rowData.list_permission !== null && (
          <div>
            <input
              type="checkbox"
              checked={rowData.list_permission == "1"}
              onChange={handleChange}
              onClick={() =>
                handleCheckboxChange(
                  "list_permission",
                  rowData.id,
                  rowIndex,
                  rowData
                )
              }
            />
            <label htmlFor="key1" className="me-4 ms-2">
              List
            </label>
          </div>
        )}
      </div>
    );
  }
  


const RolePermission = (props) => {
  //meta title
  document.title = "Permission | FundLync";
  const dispatch = useDispatch();
  const [rolePermissionList, setRolePermissionList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [selectedRoleName, setSelectedRoleName] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });

  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");

  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action", "address"],
  });

  const roleData = useSelector((state) => ({
    roles: state.addRole,
    rolePermissions: state.rolePermission.data,
  }));

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      roleName: selectedRoleName || "",
      role: selectedRole || "",
    },
    validationSchema: Yup.object({
      roleName: Yup.number().required("Please select Entity"),
    }),
  });

  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value;
        },
      },
      {
        Header: "Permission Name",
        accessor: "permission_name",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.valu;
        },
      },
      {
        Header: "Description",
        accessor: "permission_desc",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.valu;
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: (cellProps) => {
          return TableActionsComponent(cellProps,handleCheckboxChange,handleChange)
        }
      },
    ],
    []
  );

  const handlePageChange = (page,pageSize,searchKey,columnName=columnId, sortingOrder = sortingOrderStatus) =>{
    setPageSize(pageSize);
    dispatch(getRolePermissions({roleName: selectedRole,page,limit:pageSize,searchKey,columnName,sortingOrder}));
  }
  
   const handleSortColumn = (option) =>{
    setSortingOptions(option)
    const columnName=option.column;
    setColumnId(columnName)
    const sortingOrder= option.isAsc ? "asc": "desc";
    setSortingOrderStatus(sortingOrder)
    handlePageChange(1,pageSize,searchValue,columnName,sortingOrder)
  }
  
  const handleSearchFilter = (value,pageSize) => {
    setSearchValue(value)
    handlePageChange(1,pageSize,value);
  }
  const handleClearSearch = () =>{
    setSearchValue("")
    handlePageChange(1,pageSize,"")
  }

  const handleChange = () =>{
    setSearchValue("")
    handlePageChange(1,pageSize,"")
  }

  useEffect(() => {
    dispatch(getRoles());
  }, []);

  useEffect(() => {
    if (roleData?.roles?.data?.data) {
      setRoleList(roleData?.roles?.data?.data);
    }
  }, [roleData?.roles]);

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
    const values = e.target.value.split(",");
    const roleName = values[1];
    const role = values[0];

    setSelectedRoleName(roleName);
    setSelectedRole(role);

    validation.setFieldValue("roleName", roleName);
    validation.setFieldValue("role", role);

    setShowTable(true);
    dispatch(getRolePermissions({ roleName: role }));
  };

  const handleCheckboxChange = (key, id, index, rowData) => {
    confirmAlert({
      title: "Confirm",
      message: "Are you sure you want to perform this action?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            if (rowData[key] == "1") {
              rowData[key] = false;
            } else {
              rowData[key] = true;
            }
            const updatedBody = {
              roleId: validation.values.roleName,
              createPermission: rowData.create_permission,
              editPermission: rowData.edit_permission,
              viewPermission: rowData.view_permission,
              deletePermission: rowData.delete_permission,
              approvePermission: rowData.approve_permission,
              fullAccess: rowData.full_access,
              listPermission: rowData.list_permission,
              permissionId: id,
            };
            if (rowData.rolesPermissions.length > 0) {
              updatedBody.type = "update";
              updatedBody.rolePermissionId = rowData.rolesPermissions[0].id;
            } else {
              updatedBody.type = "insert";
            }
            editRolePermission(updatedBody)
              .then((response) => {
                if (response.status) {
                  getRolePermission({ roleName: validation.values.role })
                    .then((response) => {
                      setRolePermissionList(response.data.data);
                      const { totalItems, totalPages, currentPage } =
                        response.data;
                      setPagination({
                        pageIndex: currentPage,
                        pageCount: totalPages,
                        totalRecords: totalItems,
                      });
                    })
                    .catch((error) => {});
                }
              })
              .catch((error) => {});
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  useEffect(() => {
    if (roleData?.rolePermissions) {
      setRolePermissionList(roleData.rolePermissions.data);
      const { totalItems, totalPages, currentPage } = roleData.rolePermissions;
      setPagination({
        pageIndex: currentPage,
        pageCount: totalPages,
        totalRecords: totalItems,
      });
    }
  }, [roleData?.rolePermissions]);

  return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="ROLE PERMISSIONS" />
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  <Col
                    md="2"
                    className="d-flex align-items-center mb-3"
                    style={{ width: "20%" }}
                  >
                    <label className="mt-1 me-3 font-size-14">Role:</label>
                    <Input
                      name="roleType"
                      type="select"
                      onChange={(e) => {
                        const values = e.target.value.split(",");
                        validation.values.roleName = values[1];
                        validation.values.role = values[0];
                        handleSelectChange(e);
                      }}
                      value={selectedValue || ""}
                    >
                      <option value="" disabled>
                        Select role type
                      </option>
                      {roleList.map((depo) => (
                        <option key={depo.id} value={[depo.roleName, depo.id]}>
                          {depo.roleName}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  {showTable && (
                    <TableContainerV1
                      columns={columns}
                      data={rolePermissionList}
                      pagination={pagination}
                      handlePageChange={handlePageChange}
                      handleSearchFilter={handleSearchFilter}
                      // customSection={buttonSection}
                      sortOptions={sortingOptions}
                      handleSortColumn={handleSortColumn}
                      handleClearSearch={handleClearSearch}
                      className="custom-header-css"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
  );
};

export default RolePermission;
